import { render, staticRenderFns } from "./ProtectionForm.vue?vue&type=template&id=317e6eef"
import script from "./ProtectionForm.vue?vue&type=script&lang=js"
export * from "./ProtectionForm.vue?vue&type=script&lang=js"
import style0 from "./ProtectionForm.vue?vue&type=style&index=0&id=317e6eef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports